export const paymentMethodTranslations = [
    { label: "Прихід", value: "INCOME"},
    { label: "Розхід", value: "OUTCOME"}
]

const paymentTypeTranslations = {
    "CASH": "Готівка",
    "CARD": "Термінал",
    "IBAN": "Рахунок"
}

export const purposeTranslations = [
    { label: "Оплата", value: "PAYMENT" },
    { label: "Комісія", value: "COMMISSION" },
    { label: "Повернення", value: "RETURNING" }
]

export const actStatuses = {
    "PENDING": "Драфт",
    "FINALIZED": "Фіналізований"
}

export const paymentStatusTranslation = [
    { label: "Розподілено", value: "DISTRIBUTED"},
    { label: "Не розподілено", value: "NOT_DISTRIBUTED"},
    { label: "Частково розподілено", value: "PARTLY_DISTRIBUTED"}
]

export const transactionTypeTranslation = [
    { label: "Дебет", value: "DEBIT"},
    { label: "Кредит", value: "CREDIT"}
]

export const orderStatusesTranslation = [
    { label: "Нове", value: "NEW" },
    { label: "У роботі", value: "IN_PROGRESS" },
    { label: "Очікує відповіді клієнта", value: "WAITING_FOR_CLIENT" },
    { label: "Погоджено", value: "APPROVED" },
    { label: "Виконано", value: "DONE" },
    { label: "Відмінено", value: "CANCELLED" }
]

export const fieldTypesTranslation = [
    { label:"Текст", value: "STRING"},
    { label:"Число", value: "INTEGER"},
    { label:"Дробове число", value: "FLOAT"},
    { label:"Довідник", value: "DICTIONARY"}   
]

export const productStatusTranslation = [
    {label: "Активний", value: true},
    {label: "Деактивований", value: false}
]

const translations = {
    "accounting_type": "Тип обліку",
    "act_date": "Дата акту",
    "act_number": "Номер акту",
    "act_type": "Тип акту",
    "ADMIN_PANEL": "CRM",
    "admin_panel_access": "Доступ до адмінки",
    "advertiser_type": "Тип оголошень",
    "api_url": "Ендпойнт",
    "api_token": "Токен",
    "apartment_number": "Номер квартири",
    "auth": "Користувачі та ролі",
    "B2B_SKLAD_PLUGIN": "B2B Склад ",
    "building_number": "Номер будинку",
    "cagent": "Контрагент",
    "cagent_financial_data": "Фінансові дані",
    "cagents": "Контрагенти",
    "CASH_APP": "Каса",
    "CASH_APP_REPORT": "Звіт по змінам у касі",
    "cash_app_access": "Доступ до каси",
    "city": "Місто",
    "client": "Клієнт",
    "client_id": "Клієнт",
    "client_return_acts": "Акти повернення товару клієнтом",
    "client_secret": "Пароль",
    "clients": "Клієнти",
    "country": "Країна",
    "CREATE": "Створення",
    "createproduct": "Cтворити товар",
    "createproductgroup": "Створити групу товарів",
    "createservice": "Створити послугу",
    "createservicegroup": "Створити групу послуг",
    "currencies": "Валюти",
    "currency": "Валюта",
    "currencyrates": "Історія курсів валюти",
    "custom_sale_price": "Ціна продажу",
    "custom_sale_price_currency": "Валюта продажу",
    "dashboards": "Дашборди",
    "date": "Дата",
    "DELETE": "Видалення",
    "delete": "Видалення",
    "description": "Опис",
    "dictionaries": "Довідники",
    "discount": "Знижка",
    "distributor_return_acts":"Акт повернення товару постачальнику",
    "distributorreturns": "Повернення постачальнику",
    "division": "Точка продажу",
    "division_id": "Точка продажу",
    "divisions": "Точки продажу",
    "editcounteragent": "Редагування контрагента",
    "editdivision": "Редагування точки продажу",
    "editexternalact": "Редагування партнерського акту",
    "editexternalproduct": "Редагування залишку контрагента",
    "editgroup": "Редагування групи послуг",
    "editorder": "Редагування замовлення",
    "editproduct": "Редагування продукту",
    "editproductgroup": "Редагування групи товарів", 
    "editproductsreturn": "Деталі акту повернення",
    "editreception": "Редагування акту прийому",
    "editreturn": "Редагування акту повернення",
    "editsale": "Деталі акту продажу",
    "editservice": "Редагування послуги",
    "edituser": "Редагування користувача",
    "edituserrole": "Редагування ролі",
    "edrpou": "ЄДРПОУ",
    "employee_position": "Посада",
    "externalacts": "Партнерські акти",
    "externalproducts": "Залишки партнерів",
    "external_products": "Залишки партнерів",
    "fields": "Поля",
    "field_name": "Назва поля",
    "field_type": "Тип поля",
    "FINALIZED": "Фіналізований",
    "first_name": "Ім'я",
    "full_price": "Загальна ціна",
    "full_price_UAH": "Загальна ціна, грн",
    "group_name": "Назва групи",
    "identified_products": "Товари поштучного обліку",
    "identifier": "Ідентифікатор",
    "identifier_name": "Поле для ідентифікації",
    "INDIVIDUAL": "Індивідуальний",
    "is_active":"Активований",
    "is_client": "Є Клієнтом",
    "is_partner": "Є Партнером",
    "lang": "Мова",
    "last_name": "Прізвище",
    "leftovers": "Залишки",
    "LOGIN_SUCCESS": "Успішний вхід",
    "long_name": "Повна назва",
    "mandatory": "Обов'язковість",
    "marketplace": "Маркетплейс",
    "name": "Назва",
    "NEW": "Новий",
    "newcounteragent": "Новий контрагент",
    "newdivision": "Створення точки продажу",
    "newexternalact": "Створення партнерського акту",
    "newexternalproduct": "Новий товар контрагента",
    "neworder": "Нове замовлення",
    "newproductsreturn": "Новий акт повернення товару",
    "newproductstransfer": "Новий акту переміщення",
    "newreception": "Новий акт прийому товарів",
    "newreturn": "Новий акт повернення",
    "newsale": "Новий акт продажу",
    "newuser": "Новий користувач",
    "newuserrole": "Нова роль користувача",
    "newwriteoff": "Новий акт списання товарів",
    "NO_PAYMENT_REQUIRED": "Не потребує оплати",
    "NOT_PAYED": "Не оплачено",
    "note": "Опис",
    "notes": "Опис",
    "OLX_ADVERTS": "Оголошення OLX",
    "orders": "Замовлення",
    "order_products": "Товари замовлення",
    "organization": "Підрозділ",
    "organizations": "Організації",
    "organizationsettings": "Налаштування організації",
    "PARTIAL_PAYED": "Частково оплачено",
    "PAYED": "Оплачено",
    "partner": "Постачальник",
    "partner_id": "ID Партнера",
    "PARTNER_SALE": "Партнерський акт",
    "partners": "Постачальники",
    "pay_due_date": "Очікувана дата оплати",
    "pay_status": "Статус оплати",
    "payments": "Платежі",
    "PENDING": "Драфт",
    "phone": "Телефон",
    "PIECE": "Поштучний",
    "plugindetails": "Налаштування плагіну",
    "postal_code": "Поштовий індекс",
    "price": "Ціна",
    "priceUAH": "Ціна в гривні",
    "product": "Товар",
    "product_article": "Артикул",
    "product_fields_values": "Поля продукту",
    "product_group": "Група товарів",
    "productgroups": "Групи товарів",
    "product_name": "Назва товару",
    "products": "Товари",
    "productstransfer": "Переміщення товарів",
    "productstransferdetails": "Деталі акту переміщення товарів",
    "productsreception": "Прийом товару",
    "productsreturn": "Повернення товару",
    "receive_acts":"Акти отримання",
    "region": "Область",
    "remainings": "Залишки",
    "reportdetails": "Деталі звіту",
    "reports": "Звіти",
    "reportsarchive": "Архів звітів",
    "representative": "Представник",
    "roles": "Ролі",
    "root_division": "Батьківська точка продажу",
    "root_group": "Батьківська група",
    "sales": "Продажі",
    "sales_acts": "Акти продажу",
    "scope": "Права",
    "shifts": "Зміни",
    "service_article": "Артикул",
    "service_field_values": "Поля",
    "service_group": "Батьківська група",
    "servicegroups": "Перелік груп послуг",
    "services": "Послуги",
    "settlements": "Розрахунки з контрагентами",
    "short_name": "Скорочена назва",
    "status": "Статус",
    "street": "Вулиця",
    "templates": "Шаблони документів",
    "This field may not be null.": "Поле не повинне бути пустим",
    "transactions": "Транзакції",
    "type": "Тип",
    "unidentified_products": "Товари загального обліку",
    "UPDATE": "Оновлення",
    "use_product_sale_price": "Використовувати ціну з довідника",
    "user": "Користувач",
    "username": "Логін",
    "users": "Користувачі",
    "widgets": "Віджети",
    "writeoff": "Списання товарів",
    "write_off_acts": "Акти списання"
}

export const TranslatePaymentMethod = (name) => {
    return paymentMethodTranslations.find(x => x.value === name)?.label;
}

export const TranslatePaymentType = (name) => {
    return paymentTypeTranslations[name];
}

export const TranslatePaymentStatus = (name) => {
    return paymentStatusTranslation.find(x => x.value === name)?.label;
}

export const TranslateTransactionType = (name) => {
    return transactionTypeTranslation.find(x => x.value === name)?.label;
}

export const TranslateOrderStatus = (name) => {
    return orderStatusesTranslation[name];
}

export const TranslateFieldTypes = (name) => {
    console.log(name);
    return fieldTypesTranslation.find(x => x.value === name)?.label;
}

export const Translate = (name) => {
    return translations[name] === undefined ? name : translations[name]; 
}

export const UaLocale =
{
    startsWith: 'Починається з',
    contains: 'Містить',
    notContains: 'Не містить',
    endsWith: 'Закінчується на',
    equals: 'Рівно',
    notEquals: 'Не рівно',
    noFilter: 'Без фільтра',
    lt: 'Менше ніж',
    lte: 'Менше або рівно',
    gt: 'Більше ніж',
    gte: 'Більше або рівно',
    dateIs: 'Дата є',
    dateIsNot: 'Дата не є',
    dateBefore: 'Дата до',
    dateAfter: 'Дата після',
    clear: 'Очистити',
    apply: 'Застосувати',
    matchAll: 'Збігається з усім',
    matchAny: 'Збігається з будь-яким',
    addRule: 'Додати правило',
    removeRule: 'Видалити правило',
    accept: 'Так',
    reject: 'Ні',
    choose: 'Вибрати',
    upload: 'Завантажити',
    cancel: 'Скасувати',
    dayNames: [
        'Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'
    ],
    dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
        'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень',
        'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'
    ],
    monthNamesShort: ['Січ', 'Лют', 'Бер', 'Квіт', 'Трав', 'Чер', 'Лип', 'Серп', 'Вер', 'Жов', 'Лис', 'Гру']
}
